define('SageDotCom/Components/ProductCard/ProductTertiaryButton',[
    "jquery",
    "score_bootstrap/Components/Button", 
    "SageDotCom/DataLayer/Events/product-card-tertiary-button"
], function ($, Button, ProductCardTertiaryButtonEvent) {

    return function (args) {
        Button.init(args);

        // Track click on Try button
        $(args.scope).on('click', 'a', function (e) {
            new ProductCardTertiaryButtonEvent(e.currentTarget, "tertiary_link_click", "tertiary_link_click").trigger();
        });
    };
});
